var acceleratorBadge = require('../images/acceleratorBadge.svg');
var knowledgeBadge = require('../images/knowledgeBadge.svg');
var growthCenterBadge = require('../images/growthCenterBadge.svg');
var innovationBadge = require('../images/innovationBadge.svg');
var InstituteBadge = require('../images/InstituteBadge.svg');
var techappartmentBadge = require('../images/techappartmentBadge.svg');
var techparkBadge = require('../images/techparkBadge.svg');
var universityBadge = require('../images/universityBadge.svg');
var coworkBadge = require('../images/cowork.svg');

export function medalList() {
    return [{
        image: acceleratorBadge,
        englishName: "accelerator",
        persianName: "شتاب دهنده",
        hasMedal: false
    },
    {
        image: knowledgeBadge,
        englishName: "knowledgeBadge",
        persianName: "دانش بنیان",
        hasMedal: false
    },
    {
        image: growthCenterBadge,
        englishName: "growth_center",
        persianName: "مرکز رشد",
        hasMedal: false
    }, {
        image: innovationBadge,
        englishName: "innovation_center",
        persianName: "نوآوری",
        hasMedal: false
    }, {
        image: InstituteBadge,
        englishName: "institute",
        persianName: "پژوهشگاه",
        hasMedal: false
    }, {
        image: techappartmentBadge,
        englishName: "technology_department",
        persianName: "مجتمع فناوری",
        hasMedal: false
    },
    {
        image: techparkBadge,
        englishName: "park",
        persianName: "پارک علم و فناوری",
        hasMedal: false
    }, {
        image: universityBadge,
        englishName: "university",
        persianName: "دانشگاه",
        hasMedal: false
    },
    {
        image: coworkBadge,
        englishName: "co_work",
        persianName: "فضای اشتراکی",
        hasMedal: false

    }
    ];
}